import { ColumnState, FilterModel, SortModelItem } from '@ag-grid-community/core';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { LogCustomFields } from './generic-log.component';
import { UserConfigServices } from 'src/app/services/user-config.services';


export interface UserConfig{
    columnState?:ColumnState[];
}


export interface LogEntry {
    codecompany:string;
    codeproduct:string;
    nameCompany:string;
    idconf:string;
    recmodifiedon:string;
    [key: string]: any; 
    requestbody:string;
    responsebody:string;
    totalRows:number;
}

@Injectable({ providedIn: 'root' })
export class GenericLogServices implements OnDestroy {


  constructor(private http:HTTPService, private uas:UserAuthenticationServices,
    private ucs:UserConfigServices
  )  {

  }
   
  sub2:Subscription;
  userConfig: UserConfig;
 
  ngOnDestroy(): void {
    if ( this.sub2!= null ){
        this.sub2.unsubscribe();
    }
  }

  getCountQuery(
        tableName:string,
        filter: FilterModel,
        codecompany,
        codeproduct){
     let cng = `(SELECT COUNT(1) 
                FROM  ${tableName.toUpperCase()} (NOLOCK) INNER JOIN MKTPCOMPANIES C (NOLOCK) ON ${tableName.toUpperCase()}.CODECOMPANY=C.CODECOMPANY
                     WHERE ${this.uas.user.profile === 'ADMIN' ? '0=0' : `${tableName.toUpperCase()} .CODECOMPANY IN (${this.uas.getCompanies()})`}
                     ${codecompany!=null ?'AND '+ tableName + ".CODECOMPANY=" + codecompany : ""}
                     ${codeproduct!=null ?'AND '+ tableName + ".CODEPRODUCT=" + codeproduct : ""}
                     ${filter!=null ? this.mountFilter(filter,tableName.toUpperCase()) : ''}
                )`;
          return cng;
  }


  saveUserPreference(
        resourceId:string,
        preference:object) {
    return new Promise((resolve,reject)=>{
        this.ucs.saveUserResource(resourceId,this.uas.user.iduser,preference).then(d=>{
          resolve(d);
        })

    });
  }

  loadGridPreference( resourceId:string) {
        return new Promise((resolve,reject)=>{
            this.ucs.loadUserResource(this.uas.user.iduser,resourceId).subscribe({
            next:(data)=>{    
                let val:Object[] = data['Mktpuserpref'] ;
                if ( val!= null  && val.length > 0 ){
                    resolve(val[0]);
                }else{
                    resolve([]);
                }
            },
            error:(erro)=>{
                reject(erro);
            }
            });
        })
    }

  getLogsStream(
        tableName:string,
        metadataFields:LogCustomFields[],
        pageIndex: number,
        pageSize: number,
        sortMode:SortModelItem[],
        filter: FilterModel,
        codecompany,
        codeproduct
 ): Promise<LogEntry[]> {

    let ob = {
            "entityName":tableName,
            "sql":`SELECT   ${tableName.toUpperCase()}.CODECOMPANY,
                            C.NAME AS NAME_COMPANIES,
                            ${tableName.toUpperCase()}.CODEPRODUCT, 
                            ${tableName.toUpperCase()}.REQUESTBODY, 
                            ${tableName.toUpperCase()}.RESPONSEBODY,
                            ${tableName.toUpperCase()}.IDCONF,
                            ${tableName.toUpperCase()}.RECMODIFIEDON,
                            ${metadataFields.map(d=>d.field)},
                            ${this.getCountQuery(tableName, filter, codecompany, codeproduct)} as totalRows
                     FROM  ${tableName.toUpperCase()} (NOLOCK) INNER JOIN MKTPCOMPANIES C (NOLOCK) ON ${tableName.toUpperCase()}.CODECOMPANY=C.CODECOMPANY
                     WHERE ${this.uas.user.profile === 'ADMIN' ? '0=0' : `${tableName.toUpperCase()} .CODECOMPANY IN (${this.uas.getCompanies()})`}
                     ${codecompany!=null ?'AND '+ tableName + ".CODECOMPANY=" + codecompany : ""}
                     ${codeproduct!=null ?'AND '+ tableName + ".CODEPRODUCT=" + codeproduct : ""}
                     ${filter!=null ? this.mountFilter(filter,tableName.toUpperCase()) : ''}
                     ORDER BY ${this.getOrder(sortMode)}
                     OFFSET ${pageIndex} ROWS     
                     FETCH NEXT ${pageSize} ROWS ONLY`
    }

    
    return new Promise((resolve,reject)=>{
                    
        this.sub2 = this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe({
            
            next: (res:any) => {

                if( ObjectUtil.isNotEmpty(res['SQL'])){
                    let sql = res['SQL'] as Object[];

                    const mapped: LogEntry[] = sql.map((item: any) => ({
                            codecompany: item['CODECOMPANY'],
                            codeproduct: item['CODEPRODUCT'],
                            nameCompany: item['NAME_COMPANIES'],
                            idconf: item['IDCONF'],
                            recmodifiedon: new Date(item['RECMODIFIEDON']).toISOString(),
                            ...this.getMetadata(metadataFields, item),
                            requestbody: item['REQUESTBODY'] ?? {},
                            responsebody: item['RESPONSEBODY'] ?? {},
                            totalRows: item['totalRows']?? 0

                    }));

                    resolve(mapped);
                    
                }else {
                    resolve([]);
                }
            },
            error: (error:any) => {
                reject(error);
            }
        });
    });
  }

  getMetadata(metadataFields:LogCustomFields[],item:Object){
        let ob = {};
        
        if ( metadataFields.length > 0 ){
            metadataFields.forEach((field:LogCustomFields)=>{
                ob[field.field] = item[field.field];
            })
        }
        return ob;
  }

  getOrder(sortModel:SortModelItem[]){
        if ( sortModel == null || sortModel.length == 0){
            return "RECMODIFIEDON DESC"
        }else{
            let order  = '';
            for ( var sortItem of sortModel){
                if ( order == ''){
                    order += sortItem.colId + " " + sortItem.sort.toUpperCase();
                }else{
                    order += "," + sortItem.colId + " " + sortItem.sort.toUpperCase();
                }
            }
            return order;
        }
    }


  mountFilter(filter: FilterModel, tableName:string) {
        if ( Object.keys(filter).length == 0){
            return '';
        }

        let condition ='';
        
        
        Object.keys(filter).forEach(keyId=>{
            let fieldName:string = keyId.toUpperCase();
            let conditions:any[]  = [];
            if ( filter[keyId]['conditions'] == null ){
                conditions.push(filter[keyId]);
            } else{
                conditions = filter[keyId].conditions;
            }
            
            let i = 0 ;
            let innerCondition = '';
            for ( var cond of conditions){
                
                let filterType = cond.filterType;
                
                let type:string = cond.type;
                let operator:string = '';
                let value:string = '';

                switch(type){
                            case 'equals' : operator = '='; value = this.getValueFilter(cond, type, filterType);break;
                            case "endsWith":
                            case "startsWith":
                            case 'contains' : operator = ' LIKE '; value = this.getValueFilter(cond, type, filterType);break;
                            case "notContains" : operator = ' NOT LIKE ';  value = this.getValueFilter(cond, type, filterType);break;
                            case "notEqual" : operator = '!=';  value = this.getValueFilter(cond, type, filterType);break;
                            case "blank" : operator = ' IS NULL ';break;
                            case "notBlank" : operator = ' IS NOT NULL ';break;
                            case "greaterThan" : operator = '>';  value = this.getValueFilter(cond, type, filterType);break;
                            case "greaterThanOrEqual" : operator = '>=';  value = this.getValueFilter(cond, type, filterType);break;
                            case "lessThan" : operator = '<';  value = this.getValueFilter(cond, type, filterType);break;
                            case "lessThanOrEqual" : operator = '<=';  value = this.getValueFilter(cond, type, filterType);break;
                            case "inRange" : operator = ' BETWEEN ';  value = this.getValueFilter(cond, type, filterType);break;
                }    
                
                let conditionStr:string = fieldName +" "+ operator +" "+ value;
                if ( i > 0 ){
                    innerCondition = innerCondition+" "+ filter[keyId].operator+ ' '+ conditionStr;
                }else{
                    innerCondition =  innerCondition + conditionStr;
                }
                i++;
                
            }
            condition = condition + ' AND ( ' + innerCondition +' ) ';
        });

        return condition;
    }
    getValueFilter(filter: FilterModel, type: string, filterType: string): string {
        
        if ( filterType == 'text'){
            if (['equals','notEqual'].indexOf(type) >-1){
                return "'"+ filter.filter + "'";
            }
            if (['contains','notContains'].indexOf(type)>-1){
                return "'%"+ filter.filter + "%'";
            }
            if (type == 'endsWith'){
                return "'%"+ filter.filter+ "'";
            }
            if (type == 'startsWith'){
                return "'"+filter.filter + "%'";
            }
        }
        if ( filterType == "number"){
            if ( type =='inRange'){
                return filter.filter + ' AND ' + filter.to;
            }else{
                return  filter.filter;
            }

        }

        if ( filterType == "date"){ 
             if ( type =='inRange'){
                return "'"+filter.dateFrom+"'" + ' AND ' + "'"+filter.dateTo+"'";
            }else{
                return   "'"+filter.dateFrom+ "'";
            }
        }
    }
}
